module.exports = __webpack_public_path__ + "img/icon-life-time.301bfe4.svg";